// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './BlogPostPage.style';

export class BlogPostPage extends PureComponent {
    static propTypes = {
        blogPost: this.propTypes
    };

    renderCategoryName(categories) {
        if (categories?.length <= 0) {
            return null;
        }

        return (
            <span className='BlogPostPage-CategoryName'>{categories[0]?.title}</span>
        )
    }

    renderPost(item) {
        if (item?.length <= 0) {
            return null;
        }

        return (
            <div className='BlogPostPage-Container'>
                {
                    item?.map((value, index) => (
                        <div className='BlogPostPage-Content' key={index}>
                            <span className='BlogPostPage-Publishdate'>{new Date(value?.publish_time).toDateString()}</span>
                            <h1 className='BlogPostPage-Title'>{value?.title}</h1>
                            {this.renderCategoryName(value?.categories)}
                            <div className='BlogPostPage-Image'>
                                <img src={value?.featured_image} />
                            </div>
                            <div className='BlogPostPage-BlogContent' dangerouslySetInnerHTML={{ __html: value?.filtered_content }}></div>
                        </div>
                    ))
                }
            </div>
        )
    }

    render() {
        const { blogPost: { items } } = this.props;

        return (
            <div className="BlogPostPage">
                {this.renderPost(items)}
            </div>
        );
    }
}

export default BlogPostPage;
